import { Pipe, PipeTransform } from '@angular/core';
import { arrayNotEmpty } from 'src/app/utils/array.utils';
import { BenefComboModel } from 'src/graphql/generated-types';

@Pipe({
    name: 'getBeneficiaryFromId',
    standalone: false
})
export class GetBeneficiaryFromIdPipe implements PipeTransform {

  transform(benefId: number, beneficiariesList: BenefComboModel[]): BenefComboModel {
    return arrayNotEmpty(beneficiariesList)
        ? beneficiariesList.find(({Id}) => Id === benefId)
        : null;
  }

}
